export default "__VITE_ASSET__a3d4e256__"